export default "./images/survio-1BgBl-assets-single_choice.png";